import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { name: '网红塌房', path: '/category/wanghong-tafang' },
      { name: '明星八卦', path: '/category/mingxing-bagua' },
      { name: '热门事件', path: '/category/remen-shijian' },
      { name: '独家爆料', path: '/category/dujia-baoliao' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { name: '实时追踪', path: '/category/shishi-zhuizong' },
      { name: '关于我们', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '品牌口碑', path: '/about#reputation' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: '微博热搜', path: '#', external: true },
      { name: '知乎热榜', path: '#', external: true },
      { name: '百度热点', path: '#', external: true },
      { name: '抖音热点', path: '#', external: true },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();

    if (honeypotVal !== '') {
      setSubscribeStatus('success');
      setSubscribeMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setSubscribeStatus('loading');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email);

      const res = await fetch('http://818tp.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await res.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (res.ok && parsed?.code === 'OK') {
        setSubscribeStatus('success');
        setSubscribeMsg('订阅成功！感谢您的关注，最新爆料将第一时间发送到您的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
        if (serverMsg.toLowerCase().includes('spam')) {
          setSubscribeStatus('error');
          setSubscribeMsg('系统检测到异常，请稍后再试。');
        } else {
          setSubscribeStatus('error');
          setSubscribeMsg(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <Link to="/" className="flex items-center gap-2 mb-6 cursor-pointer" aria-label="吃瓜51网首页">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500 rounded-lg">
                <span className="font-heading font-black text-lg text-foreground-950 leading-none">瓜</span>
              </div>
              <span className="font-heading font-black text-xl text-foreground-950 tracking-tight">
                吃瓜<span className="text-accent-600">51</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-sm">
              吃瓜51网 —— 汇聚全网最新最热的吃瓜爆料与热门事件。每日独家更新网红塌房黑料，实时追踪不停歇，做您身边最可靠的吃瓜情报站。
            </p>

            <form
              onSubmit={handleSubscribe}
             
              id="footer-subscribe-form"
              className="max-w-sm"
            >
              <label htmlFor="footer-email" className="block text-xs font-label font-medium text-foreground-500 mb-2">
                订阅每日爆料
              </label>
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  id="footer-email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="输入您的邮箱"
                  className="flex-1 px-4 py-2.5 text-sm bg-transparent border-b border-foreground-300 focus:border-accent-500 outline-none transition-colors text-foreground-950 placeholder:text-foreground-400"
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className="px-5 py-2.5 text-sm font-label font-medium border border-foreground-300 text-foreground-700 rounded-lg hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer disabled:opacity-50"
                >
                  {subscribeStatus === 'loading' ? '提交中...' : '订阅'}
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="anti-spam-field"
              />
              {subscribeStatus === 'success' && (
                <p className="mt-2 text-xs text-accent-700">{subscribeMsg}</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="mt-2 text-xs text-red-600">{subscribeMsg}</p>
              )}
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-label font-bold text-foreground-950 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      {link.external ? (
                        <a
                          href={link.path}
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                          className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                        >
                          {link.name}
                        </a>
                      ) : (
                        <Link
                          to={link.path}
                          className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                        >
                          {link.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 吃瓜51网 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}